export default __webpack_public_path__ + "static/media/hivee.7c5e06b1.svg";